module.exports = __webpack_public_path__ + "img/horizontal_7_4_7042.bb3e1ac8.png";